<template lang="pug">
dv-select(
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
  template(v-if="!hasValue && !defaultTemplates" #prepend-inner)
    p(:class="{ 'text-nowrap': noTextWrap }") {{ placeholder | upperFirst }}
  template(v-if="((multiple && hasValue) || !hasValue) && !defaultTemplates" #selection="{ index }")
    slot(name="selection" v-bind="{ index }")
      template(v-if="multiple && hasValue")
        p(v-if="!index") {{ placeholder | upperFirst }}: {{ (value && value.length) || 1}}
      template(v-if="!hasValue")
        .d-none
</template>

<script>
import { upperFirst } from 'lodash';
import DvSelect from './DvSelect.vue';

export default {
  components: { DvSelect },
  filters: {
    upperFirst,
  },
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    paddingX: {
      type: [Number, String],
      default: 8,
    },
    placeholder: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    defaultTemplates: {
      type: Boolean,
      default: false,
    },
    noTextWrap: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    hasValue() {
      const { value } = this;
      if (Array.isArray(value)) {
        return !!value?.length;
      }
      return !!value;
    },
    extendAttrs() {
      const { value, multiple, placeholder, defaultTemplates } = this;
      return {
        solo: true,
        flat: true,
        dense: true,
        outlined: false,
        height: 28,
        multiple,
        class: [
          'dv-minify-select',
          'rounded-4',
        ],
        placeholder,
        value,
        defaultTemplates,
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dv-minify-select {
  $padding-x: calc(v-bind(paddingX) * 1px);
  &::v-deep .v-input {
    color: inherit !important;
    border: 1px solid transparent;
    &.v-select--is-menu-active {
      border-color: #{$ui-primary} !important;
    }
    & > .v-input__control {
      min-height: unset !important;
      color: inherit !important;
      & > .v-input__slot {
        color: inherit !important;
        padding-left: $padding-x !important;
        padding-right: $padding-x !important;
        & > .v-select__slot {
          & > .v-select__selections {
            color: inherit !important;
            & > .v-select__selection {
              color: inherit !important;
              margin: 0px !important;
              max-width: unset !important;
            }
            & > input {
              max-width: min-content !important;
            }
          }
          & > .v-input__append-inner {
            & > .v-input__icon > .v-icon > .v-icon__component,
            & > .v-input__icon > .v-icon,
            & > .v-input__icon {
              width: 16px !important;
              height: 16px !important;
              min-width: 16px !important;
            }
          }
        }
      }
    }
  }
}
</style>
